import { Typography, useMediaQuery, useTheme } from '@mui/material';

type KnobProps = { value: number };

const KnobValue = ({ value }: KnobProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (isMobile) return null;
  return <Typography>{value.toFixed(2)}</Typography>;
};

export default KnobValue;
